<template>
  <div>
    <vs-tabs>
      <vs-tab label="WR">
        <vs-card style="border-radius: 20px; text-align: center">
          <vs-row>
            <p>Work Request Logs</p>
            <vs-spacer></vs-spacer>
            <vs-icon icon="print" color="warning"></vs-icon>
          </vs-row>

          <vs-table :data="mockdata">
            <template slot="header">
              <vs-th
                v-for="item in mockheader"
                :key="item.name"
                sort-key="name"
                id="noWrap"
                ><p>{{ item }}</p>
                <!-- <span><vs-icon icon="unfold_more" size="13px"></vs-icon></span> -->
              </vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in mockdata">
                <vs-td :data="data[indextr].ID">
                  <p># {{ data[indextr].ID }}</p>
                </vs-td>
                <vs-td :data="data[indextr].Priority">
                  <vs-row>
                    <vs-spacer />
                    <vs-icon icon="layers"></vs-icon>
                    <p class="ml-2 mt-1">
                      {{ data[indextr].Priority }}
                    </p></vs-row
                  >
                </vs-td>
                <vs-td :data="data[indextr].Name">
                  <a href="#">{{ data[indextr].Name }}</a>
                </vs-td>
                <vs-td :data="data[indextr].Comment">
                  <a href="#">{{ data[indextr].Comment }}</a>
                </vs-td>
                <vs-td :data="data[indextr].Due_Date">
                  <p>{{ data[indextr].Due_Date }}</p>
                </vs-td>
                <vs-td :data="data[indextr].Assigned_to">
                  <a href="#">{{ data[indextr].Assigned_to }}</a>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-card>
      </vs-tab>
      <vs-tab label="WO">
        <vs-card style="border-radius: 20px">
          <vs-row>
            <p>Work Order Logs</p>
            <vs-spacer></vs-spacer>
            <vs-icon icon="print" color="warning"></vs-icon>
          </vs-row>
          <vs-table :data="mockdata">
            <template slot="header">
              <vs-th
                v-for="item in mockheader"
                :key="item.name"
                sort-key="name"
                id="noWrap"
                ><p>{{ item }}</p>
                <!-- <span><vs-icon icon="unfold_more" size="13px"></vs-icon></span> -->
              </vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in mockdata">
                <vs-td :data="data[indextr].ID">
                  <p># {{ data[indextr].ID }}</p>
                </vs-td>
                <vs-td :data="data[indextr].Priority">
                  <vs-row>
                    <vs-spacer />
                    <vs-icon icon="layers"></vs-icon>
                    <p class="ml-2 mt-1">
                      {{ data[indextr].Priority }}
                    </p></vs-row
                  >
                </vs-td>
                <vs-td :data="data[indextr].Name">
                  <a href="#">{{ data[indextr].Name }}</a>
                </vs-td>
                <vs-td :data="data[indextr].Comment">
                  <a href="#">{{ data[indextr].Comment }}</a>
                </vs-td>
                <vs-td :data="data[indextr].Due_Date">
                  <p>{{ data[indextr].Due_Date }}</p>
                </vs-td>
                <vs-td :data="data[indextr].Assigned_to">
                  <a href="#">{{ data[indextr].Assigned_to }}</a>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-card>
      </vs-tab>
      <vs-tab label="Part">
        <vs-card style="border-radius: 20px">
          <vs-row>
            <p>Part Logs</p>
            <vs-spacer></vs-spacer>
            <vs-icon icon="print" color="warning"></vs-icon>
          </vs-row>
          <vs-table :data="mockdata">
            <template slot="header">
              <vs-th
                v-for="item in mockheader"
                :key="item.name"
                sort-key="name"
                id="noWrap"
                ><p>{{ item }}</p>
                <!-- <span><vs-icon icon="unfold_more" size="13px"></vs-icon></span> -->
              </vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in mockdata">
                <vs-td :data="data[indextr].ID">
                  <p># {{ data[indextr].ID }}</p>
                </vs-td>
                <vs-td :data="data[indextr].Priority">
                  <vs-row>
                    <vs-spacer />
                    <vs-icon icon="layers"></vs-icon>
                    <p class="ml-2 mt-1">
                      {{ data[indextr].Priority }}
                    </p></vs-row
                  >
                </vs-td>
                <vs-td :data="data[indextr].Name">
                  <a href="#">{{ data[indextr].Name }}</a>
                </vs-td>
                <vs-td :data="data[indextr].Comment">
                  <a href="#">{{ data[indextr].Comment }}</a>
                </vs-td>
                <vs-td :data="data[indextr].Due_Date">
                  <p>{{ data[indextr].Due_Date }}</p>
                </vs-td>
                <vs-td :data="data[indextr].Assigned_to">
                  <a href="#">{{ data[indextr].Assigned_to }}</a>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-card>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mockheader: [
        "ID",
        "Priority",
        "Name",
        "Comment",
        "Due_Date",
        "Assigned_to",
      ],
      mockdata: [
        {
          ID: 40,
          Priority: "Low Priority",
          Name: "00_Interlink-#12345",
          Comment: "Test Com...",
          Due_Date: "2022/01/18 12:00 AM",
          Assigned_to: "Unassigned",
        },
        {
          ID: 41,
          Priority: "Low Priority",
          Name: "00_Interlink-#12345",
          Comment: "Test Com...",
          Due_Date: "2022/01/18 12:00 AM",
          Assigned_to: "Unassigned",
        },
        {
          ID: 42,
          Priority: "Low Priority",
          Name: "00_Interlink-#12345",
          Comment: "Test Com...",
          Due_Date: "2022/01/18 12:00 AM",
          Assigned_to: "Unassigned",
        },
      ],
    };
  },

  mounted() {
    this.ListlogWO();
    this.ListlogWR();
  },
  methods: {
    ListlogWO() {

      this.$API.ge

    },
    ListlogWR() {},
  },
};
</script>

<style></style>
